import React from 'react'
import { Container } from 'react-bootstrap'

import { APP_NAME } from '../constants/constants'

const Footer: React.FC = () => (
  <footer className="site-footer bg-light p-3 border-top text-muted">
    <Container className="d-flex justify-content-between gap-3">
      <div>
        {APP_NAME} &copy; {new Date().getFullYear()}
      </div>
    </Container>
  </footer>
)

export default Footer
